export default [
   {'const': 'M', 'title': 'Muslim'},
   {'const': 'B', 'title': 'Buddhist'},
   {'const': 'C', 'title': 'Christian'},
   {'const': 'H', 'title': 'Hindu'},
   {'const': 'O', 'title': 'Other'},
   {'const': 'R', 'title': 'Refuse to answer'},
]
